(() => {
  // Add confirmed brand aliases here. Multi-word entries also accept their
  // joined and hyphenated forms. Never infer aliases from partial substrings.
  const BRAND_ALIASES = [
    { canonical: 'casablanca', aliases: ['casa blanca'] },
    { canonical: 'ami paris', aliases: ['ami'], exact: true },
    { canonical: 'amiri', aliases: [], exact: true },
    { canonical: 'canada goose', aliases: [] },
    { canonical: 'moose knuckles', aliases: [] },
    { canonical: 'stone island', aliases: [] },
    { canonical: 'louis vuitton', aliases: [] },
    { canonical: 'polo ralph lauren', aliases: [] }
  ];

  const compactSpaces = value => String(value || '').trim().replace(/\s+/g, ' ');
  const brandKey = value => compactSpaces(value).toLowerCase().replace(/[\s\-\u2010-\u2015]+/g, '');
  const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const brandsByKey = new Map();
  const patterns = [];
  for (const brand of BRAND_ALIASES) {
    for (const alias of [brand.canonical, ...brand.aliases]) {
      brandsByKey.set(brandKey(alias), brand);
      patterns.push({
        alias,
        pattern: alias.split(' ').map(escapePattern).join('[\\s\\-\\u2010-\\u2015]*')
      });
    }
  }
  // Prefer AMI Paris over AMI, and require complete Unicode word boundaries:
  // AMI must never rewrite AMIRI, Miami, or a model/SKU containing those letters.
  const brandPattern = new RegExp(
    `(^|[^\\p{L}\\p{N}_\\-\\u2010-\\u2015])(${patterns.sort((a, b) => b.alias.length - a.alias.length).map(entry => entry.pattern).join('|')})(?=$|[^\\p{L}\\p{N}_\\-\\u2010-\\u2015])`,
    'giu'
  );
  const hasSearchSyntax = query => /[":()\\*]|(?:^|\s)[+-]\S|\b(?:AND|OR|NOT)\b/.test(query);

  const normalize = value => {
    const query = String(value || '').trim();
    // Preserve field searches, phrases, exclusions, boolean operators and SKUs.
    if (hasSearchSyntax(query)) return query;
    return compactSpaces(query).replace(brandPattern, (match, boundary, alias) => {
      const brand = brandsByKey.get(brandKey(alias));
      // Shopify's native broad matching can still return AMIRI for AMI Paris.
      // Exact phrases constrain only these confirmed overlapping brands, on
      // both full and predictive search, without changing product data/vendors.
      return boundary + (brand.exact ? `"${brand.canonical}"` : brand.canonical);
    });
  };

  const matchesDesigner = (name, value) => {
    const query = compactSpaces(value).toLowerCase();
    if (!query) return true;
    const canonical = brandsByKey.get(brandKey(query))?.canonical;
    const candidate = compactSpaces(name).toLowerCase();
    if (canonical) {
      return (brandsByKey.get(brandKey(candidate))?.canonical || candidate) === canonical;
    }
    // Keep incremental designer browsing, but start at a word boundary instead
    // of matching arbitrary substrings inside unrelated designer names.
    return candidate.split(/[\s\-\u2010-\u2015]+/).some((_, index, words) =>
      words.slice(index).join(' ').startsWith(query.replace(/[\-\u2010-\u2015]+/g, ' '))
    );
  };

  window.DripnordSearch = Object.freeze({ normalize, matchesDesigner });
})();
